import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, BankAccountTransferDialogueHandler } from './types';
import BankAccountTransferDialogueContext from './BankAccountTransferContext';

const { ConfirmationDialogue } = vp;

type BankAccountTransferDialogueProps = {
  handleDialogue: DialogueHandler<BankAccountTransferDialogueHandler>;
};

type FC = FunctionComponent<BankAccountTransferDialogueProps>;

const BankAccountTransferDialogue: FC = ({ handleDialogue }: BankAccountTransferDialogueProps) => {
  const { showBankAccountTransferErrorAlert, bankAccountTransferError } = useContext(
    BankAccountTransferDialogueContext,
  );

  return useMemo(
    () => (
      <div>
        {/* EFT Fund Error */}
        <ConfirmationDialogue
          isVisible={showBankAccountTransferErrorAlert}
          title="Error! The transaction was not completed."
          status="error"
          subTitle={`${bankAccountTransferError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showBankAccountTransferErrorAlert, bankAccountTransferError],
  );
};

export default BankAccountTransferDialogue;
